import { render, staticRenderFns } from "./DraftInvoicePreparer.vue?vue&type=template&id=fd23833c&scoped=true&"
import script from "./DraftInvoicePreparer.vue?vue&type=script&lang=ts&"
export * from "./DraftInvoicePreparer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd23833c",
  null
  
)

export default component.exports